module.exports = __webpack_public_path__ + "media/assets/img/portrait/small/avatar-s-20-e8861d8caf03a6a986fd7a498fb18d87.jpg";